import React from 'react';

import OverviewTopBar from '@/components/bars/overview-top-bar';
import { SearchValue } from '@/components/bars/search-bar';

interface MinimumData {
  peripheralId?: string;
  name: string;
  description: string;
}

interface Properties<T extends MinimumData = MinimumData> {
  search: SearchValue[];
  page: number;
  pageSize: number;
  filteredPeripherals: T[];
  handlePageChange: (page: number) => void;
  handleSearchChange: (val: SearchValue[]) => void;
}

interface State {}

class DevicesTopBar extends React.Component<Properties, State> {
  public render() {
    const { search, page, pageSize, filteredPeripherals, handlePageChange, handleSearchChange } = this.props;

    const suggestions: SearchValue[] = this.generateSuggestions();

    return (
      <OverviewTopBar
        search={search}
        suggestions={suggestions}
        page={page}
        pageSize={pageSize}
        handlePageChange={handlePageChange}
        handleSearchChange={handleSearchChange}
        totalCount={filteredPeripherals.length}
      />
    );
  }

  private generateSuggestions = (): SearchValue[] => {
    const { filteredPeripherals } = this.props;
    // Store all the suggestions in a map, to avoid duplicates.
    const suggestions: { [key: string]: SearchValue } = {};

    filteredPeripherals.forEach((peripheral) => {
      // If we haven't started searching yet, include all results.
      if (!this.props.search.length) {
        const name = peripheral.name.toLowerCase();
        if (name) {
          suggestions[name] = {
            label: peripheral.name,
            value: {
              type: 'string',
              value: name,
            },
          };
        }
        const description = peripheral.description.toLowerCase();
        if (description) {
          suggestions[description] = {
            label: peripheral.description,
            value: {
              type: 'string',
              value: description,
            },
          };
        }
        const peripheralId = peripheral.peripheralId;
        if (peripheralId) {
          const lowerCasedPeripheralId = peripheralId.toLowerCase();
          suggestions[lowerCasedPeripheralId] = {
            label: peripheralId,
            value: {
              type: 'string',
              value: lowerCasedPeripheralId,
            },
          };
        }
      } else {
        // Filter out both results and remaining suggestions, based on the search filter.
        let foundInSearch: boolean | undefined = false;
        this.props.search.map((searchTerm) => {
          if (searchTerm && searchTerm.value && searchTerm.value.value) {
            const name = peripheral.name.toLowerCase();
            const description = peripheral.description.toLowerCase();
            const peripheralId = peripheral.peripheralId;
            const searchTermValue = searchTerm.value.value.toLowerCase();
            foundInSearch =
              name.includes(searchTermValue) ||
              description.includes(searchTermValue) ||
              peripheralId?.includes(searchTermValue);
            if (foundInSearch) {
              suggestions[name] = {
                label: peripheral.name,
                value: {
                  type: 'string',
                  value: name,
                },
              };
              suggestions[description] = {
                label: peripheral.description,
                value: {
                  type: 'string',
                  value: description,
                },
              };

              if (peripheralId) {
                const lowerCasedPeripheralId = peripheralId.toLowerCase();
                suggestions[lowerCasedPeripheralId] = {
                  label: peripheralId,
                  value: {
                    type: 'string',
                    value: lowerCasedPeripheralId,
                  },
                };
              }
            }
          }
        });
      }
    });

    // Convert the map to an array of SearchValue.
    return Object.keys(suggestions).map((k) => {
      return suggestions[k];
    });
  };
}

export default DevicesTopBar;
